<div class="under-development-checks" aria-label="Current status">
  <div class="under-development-check" *ngFor="let check of checks">
    <strong>{{ check.title }}</strong>
    <span>{{ check.description }}</span>
  </div>
</div>
